import { useEffect, useState } from "react";
import styled from "styled-components";
import Pagination from "../Pagination";
import StaticTabs from "../StaticTabs";
import SearchField from "../forms/SearchField";
import EventCards from "./EventCards";
import CreateEvent from "./CreateEvent";
import StatusMessage from "../message/StatusMessage";
import CreateEmail from "../leads/CreateEmail";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import {
	reqOptions,
	fetchAPI,
	HOST_URL,
	getCookie,
} from "../../assets/js/help_func";

const MainEvents = (props) => {
	const [data, setData] = useState(props.data && props.data);
	const [registeredUser, setRegisteredUser] = useState(0);
	const [createEvents, setCreateEvents] = useState();
	const [status, setStatus] = useState();
	const [error, setError] = useState();
	const [openModal, setOpenModal] = useState(false);
	const [adminNav, setAdminNav] = useState(false);
	const [sendEmail, setSendEmail] = useState(false);
	const [events, setEvents] = useState({});

	const username = useSelector((state) => state.username.company);
	const router = useRouter();
	const { filter } = router.query;

	useEffect(() => {
		if (getCookie("u_id")) {
			setAdminNav(true);
		}

		// Add Created event to data results objects
		if (createEvents && createEvents.id) {
			if (data && data.count) {
				data.results.unshift(createEvents);
			} else {
				setData({
					count: 1,
					next: null,
					previous: null,
					results: [createEvents],
				});
			}
			setCreateEvents();
			setOpenModal(false);
		}

		if (!events?.length) {
			fetchAPI(
				setEvents,
				`${HOST_URL}/api/v1/events/${username}/basic_list/`,
				reqOptions("GET", null, true),
				true
			);
		}
	}, [createEvents, registeredUser, error]);

	return (
		<>
			<StatusMessage status={status} setStatus={setStatus} />
			<div>
				<LeadListWrapper>
					<div className="search_tab">
						<StaticTabs categories={["All", "Upcoming", "Completed"]} />

						<div className="apparent event_search">
							<ReactSendEmail>
								<SearchField />
								<div>
									{adminNav && (
										<button
											className="important-btn"
											onClick={() => setOpenModal(true)}
										>
											{" "}
											Add Event{" "}
										</button>
									)}
								</div>
							</ReactSendEmail>
						</div>

						{sendEmail && (
							<CreateEmail
								selected={sendEmail}
								setSendEmail={setSendEmail}
								setData={setData}
								status={status}
								setStatus={setStatus}
								error={error}
								setError={setError}
								messageTypes="EVENT"
								groupName="events"
								groupUrlPath={`/api/v1/events/${username}/basic_list/`}
							/>
						)}

						<CreateEvent
							open={openModal}
							onClose={() => setOpenModal(false)}
							setData={setCreateEvents}
							setStatus={setStatus}
							setError={setError}
							status={status}
							error={error}
							urlPath={`/api/v1/events/${username}/create/`}
							methods="POST"
						/>
					</div>

					{data && data.results ? (
						<div className="fourcard">
							{data.results.map((option) => {
								return (
									<EventCards
										key={option.id}
										options={option}
										username={props.username}
										adminNav={adminNav}
									/>
								);
							})}
						</div>
					) : (
						""
					)}
					{/* </div> */}
					<div className="overflow-auto">
						<Pagination
							data={data}
							setData={setData}
							limit={10}
							access={false}
							urlPath={`/api/v1/events/${username}/?`}
						/>
					</div>
				</LeadListWrapper>
			</div>
		</>
	);
};

export default MainEvents;

const LeadListWrapper = styled.section`
	display: block;
	margin-top: 70px;
	.search_tab {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media (max-width: 540px) {
			.search_set {
				width: 100%;
			}
		}
	}
	@media (max-width: 540px) {
		.event_search {
			margin-top: 15px;
		}
		.tabs {
			margin-bottom: 5px;
		}
	}
	.apparent.event_search {
		.event-input {
			width: 100%;
			max-width: 300px;
		}
	}
	.select-btn {
		height: 45px !important;
	}
	.FilterArray__SelectMe-sc-3ae860fc-0 {
		width: 200px;
		height: 50px;
		margin-top: 0;
		margin-right: 15px;
		.select_me .select-btn {
			width: 300px;
		}
	}
	.FilterObjects__SelectMe-sc-bbce2cb4-0 {
		width: 180px !important;
		.select_content {
			width: 300px;
		}
	}
	.event_container .blog_wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
	}
	.overflow-auto {
		overflow: auto;
	}
	.each_us {
		display: inline-block;
	}
	.blog_control {
		width: 100%;
		margin-top: 50px;
		border-bottom: 1px solid #eaeaea;
	}
	.FilterObjects__SelectMe-sc-4d5bd5de-0 {
		width: 150px;
	}

	.container {
		margin-bottom: 20px;
	}
	.blog_control {
		width: 100%;
		margin-top: 50px;
	}
	.fourcard {
		justify-content: center;
		.each_card {
			margin: 10px;
		}
	}

	.search_tab {
		justify-content: space-between;
	}

	@media (min-width: 768px) {
		.blog_control {
			width: 45%;
		}
		.apparent.event_search {
			width: 80%;

			justify-content: flex-end;
			.event-input {
				width: 50%;
				max-width: 300px;
			}
			.important-btn {
				margin-top: 0px;
				height: 45px;
				margin-left: 15px;
			}
		}
		.StaticTabs__TabsSearch-sc-ff584c77-0 {
			width: 300px;
			overflow: hidden !important;
		}
	}
	@media (min-width: 1024px) {
		.blog_control {
			width: 30%;
		}
	}
`;

const ReactSendEmail = styled.div`
	display: flex;
	flex-wrap: wrap;
	cursor: pointer;
	.send_email {
		border: 1px solid rgba(44, 51, 58, 0.2);
		padding: 0 10px;
		border-radius: 5px;
		height: 45px;
		margin-right: 15px;

		img {
			width: auto;
			margin-right: 5px;
			position: relative;
			top: 5px;
		}
		span {
			display: inline-block;
			position: relative;
		}
	}
	.search_set {
		min-width: 270px;
	}
	.select_me {
		width: 150px;
		margin: 0px 10px;
	}
	@media (min-width: 720px) {
		width: 1200px !important;
	}
`;
